import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  empty: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 300,
  },

  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(3),
    flex: 1,
  },

  image: {
    width: '100%',
    maxWidth: 140,
  },
}));
